<script>
    import SecurityService from '../services/security';
    import Button from 'primevue/button';
    import Card from 'primevue/card';
    import InputText from 'primevue/inputtext';
    import SelectButton from 'primevue/selectbutton';
    import Password from 'primevue/password';
    import Toast from 'primevue/toast'; 

    import { required } from "@vuelidate/validators";
    import { useVuelidate } from "@vuelidate/core";

    export default{
        setup: () => ({ v$: useVuelidate() }),
        components: { Card, Button, InputText, SelectButton, Password, Toast},
        data(){
            return{
                formData: {
                    username: '',
                    password: ''
                },
                selectedLanguage: this.$store.state.security.language,
                 languages: [ 
                    {name: 'English', code: 'en', cls: 'flag flag-uk', src: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAeAQMAAABt+G7kAAAAA1BMVEVMaXFNx9g6AAAAAXRSTlMAQObYZgAAAAtJREFUeF5jGHYAAADSAAEzF5gpAAAAAElFTkSuQmCC'},
                    {name: 'Italiano', code: 'it',cls: 'flag flag-it',  src: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAeAQMAAABt+G7kAAAAA1BMVEVMaXFNx9g6AAAAAXRSTlMAQObYZgAAAAtJREFUeF5jGHYAAADSAAEzF5gpAAAAAElFTkSuQmCC'}
                ],
                submitted: false,
                disabled: false,
                changePasswordDialogVisible: false
            }
        },
        validations(){
           return {
                formData: {
                    username: {required},
                    password: {required}
                }
            }
        },
        methods: {      
            setLanguage(e){
                this.$store.dispatch("security/setLanguage", e.value);
                this.$root.$i18n.changeLocale(this.$store.state.security.language);
            },
            onSubmit(valid) {
                this.submitted = true;
                if (!valid) {
                    // this.$toast(message);
                }else{
                    this.$store.dispatch("generic/setLoading", true);
                    this.disabled = true;

                    SecurityService.login(this.formData, response => {
                        this.disabled = false;
                        this.$store.dispatch("generic/setLoading", false);
                        if(response.success){
                            this.$store.dispatch("security/setUser", response);
                            this.$store.dispatch("security/setMenu", []);
                            location.reload();
                        }else{
                            if(response.data.passwordMustBeChanged){
                                this.$router.push({ name: 'update-password', params: { username: this.formData.username } })
                            }else{
                                this.$toast.add({detail: response?.data?.message ?? "Autenticazione fallita. Controlla username e password", life:3000, severity:'error'});
                            }
                        }
                    });
                }
            }
        }
    }

</script>

<template>
  <Toast position="top-right" /> 
	<div class="login-body">
		<div class="login-wrapper">
			<div class="login-panel">
				<Card style="margin: auto;padding: 18px;">
                    <template #title>
                        <img src="/layout/images/logo-down-light-gradient.png" style="width: 100%;" />
                        <!-- <div>{{$t('welcomeMessage')}}</div> -->
                    </template>
                    <template #content>
                        <form @submit.prevent="onSubmit(!v$.$invalid)">
                            <div class="formgrid" >
                                <div class="my-3">
                                    <span class="p-float-label" >
                                        <InputText style="padding-right: 2.5rem;" id="username" type="text" v-model="v$.formData.username.$model" :disabled="disabled" :class="{'p-invalid':v$.formData.username.$invalid && submitted, 'w-full': true}"/>
                                        <label for="username" :class="{'p-error':v$.formData.username.$invalid && submitted}">{{$t('users.username')}}</label>
                                    </span>
                                    <small v-if="(v$.formData.username.$invalid && submitted) || v$.formData.username.$pending.$response" class="p-error">{{v$.formData.username.required.$message.replace('Value', 'Username')}}</small>
                                </div>
                                <div class="my-3 pt-3">
                                    <span class="p-float-label" >
                                        <Password id="password" v-model="formData.password" :feedback="false" inputClass="w-full" toggleMask :class="{'p-invalid':v$.formData.password.$invalid && submitted, 'w-full': true}" v-on:keyup.enter="onSubmit(!v$.$invalid)"></Password>
                                        <label for="password" :class="{'p-error':v$.formData.password.$invalid && submitted}">{{$t('users.password')}}</label>
                                    </span>
                                    <small v-if="(v$.formData.password.$invalid && submitted) || v$.formData.password.$pending.$response" class="p-error">{{v$.formData.password.required.$message.replace('Value', 'Password')}}</small>
                                </div>
                                <div class="my-3">
                                    <router-link to="/input-for-reset-password">{{$t('changePassword.forgotPassword')}}</router-link>
                                </div>
                                <div class="" style="text-align: center;">
                                    <SelectButton v-model="selectedLanguage" :options="languages" optionLabel="name" optionValue="code" @change="setLanguage" :unselectable="false">
                                        <template #option="slotProps">
                                            <div class="car-option">
                                                <img :src="slotProps.option.src" :class="slotProps.option.cls" width="30" data-v-2b22f11f="">
                                                <div>{{slotProps.option.name}}</div>
                                            </div>
                                        </template>
                                    </SelectButton>

                                </div>
                                <div class="my-3">
                                </div>
                            </div>
                        </form>
                    </template>
                    <template #footer> 
                        <Button icon="" :label="$t('btn.login')" type="submit" class="w-full" @click="onSubmit(!v$.$invalid)" />
                    </template>
                </Card>
			</div>
			<div class="login-image">
				<div class="login-image-content" style="margin: auto;text-align: center;">
					<!-- <h1><img src="/layout/images/logo-white.png" style="width: 50%;" /></h1>
					<h1>ISAB</h1> -->
					<h4 style="color:#212121;font-style: italic; line-height: 40px;">
                        "Ciao! Mi chiamo SIM e rappresento un nuovo applicativo di ultima generazione a supporto delle vostre attività quotidiane. 
                        <br />Sono stato progettato sulla base dell’esperienza pluriennale fatta insieme a voi e per acquisire qualità e autonomia crescente finalizzata a migliorare la vostra esperienza. 
                        <br />Possiedo un’ottima capacità di interazione con i colleghi (LIMS, INFOIL, PI etc.), con gli utenti e con gli amministratori di sistema. 
                        <br />Inoltre, possiedo una grande propensione nell’ imparare dalle interazioni con gli utenti e migliorare la mia capacità di supportare il vostro lavoro."
					</h4>
                    <img src="/layout/images/sim-signed.png" style="width: 5%;float: right;margin-right: 20%;" />
				</div>
				<div class="image-footer" style="width: 100%;">
                    <img src="/layout/images/fincons.png" style="width: 20%;" />
                    <!-- <img src="/layout/images/isab-logo.png" style="width: 15%;bottom: 5px;right: 0;position: absolute;" /> -->
				</div>
			</div>
		</div>
	</div>
</template>
